import { createApiSaga } from '../../sagaGenerator';
import { apiDelete, apiGet } from '../../../middleware/api';
import {
  REFERENCE_INFO_REQUEST,
  REFERENCE_INFO_VOLCANO_REQUEST,
  REFERENCE_INFO_VOLCANO_DELETE_REQUEST,
  REFERENCE_INFO_TSUNAMI_REQUEST,
  REFERENCE_INFO_TSUNAMI_DELETE_REQUEST,
  REFERENCE_INFO_RUNUP_REQUEST,
  REFERENCE_INFO_RUNUP_DELETE_REQUEST,
  REFERENCE_INFO_EARTHQUAKE_REQUEST,
  REFERENCE_INFO_EARTHQUAKE_DELETE_REQUEST,
  REFERENCE_INFO_EARTHQUAKE_DELETE_FAILURE,
  REFERENCE_INFO_EARTHQUAKE_DELETE_SUCCESS,
  REFERENCE_INFO_EARTHQUAKE_FAILURE,
  REFERENCE_INFO_EARTHQUAKE_SUCCESS,
  REFERENCE_INFO_FAILURE,
  REFERENCE_INFO_RUNUP_DELETE_FAILURE,
  REFERENCE_INFO_RUNUP_DELETE_SUCCESS,
  REFERENCE_INFO_RUNUP_FAILURE,
  REFERENCE_INFO_RUNUP_SUCCESS,
  REFERENCE_INFO_SUCCESS,
  REFERENCE_INFO_TSUNAMI_DELETE_FAILURE,
  REFERENCE_INFO_TSUNAMI_DELETE_SUCCESS,
  REFERENCE_INFO_TSUNAMI_FAILURE,
  REFERENCE_INFO_TSUNAMI_SUCCESS,
  REFERENCE_INFO_VOLCANO_DELETE_FAILURE,
  REFERENCE_INFO_VOLCANO_DELETE_SUCCESS,
  REFERENCE_INFO_VOLCANO_FAILURE,
  REFERENCE_INFO_VOLCANO_SUCCESS,
} from './referenceInfoReducer';


const getReferenceSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}`, ...action }),
  requestType: REFERENCE_INFO_REQUEST,
  successType: REFERENCE_INFO_SUCCESS,
  failureType: REFERENCE_INFO_FAILURE,
});

const getVolcanoesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}/volcanoes`, ...action }),
  requestType: REFERENCE_INFO_VOLCANO_REQUEST,
  successType: REFERENCE_INFO_VOLCANO_SUCCESS,
  failureType: REFERENCE_INFO_VOLCANO_FAILURE,
});

const getEarthquakesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}/earthquakes`, ...action }),
  requestType: REFERENCE_INFO_EARTHQUAKE_REQUEST,
  successType: REFERENCE_INFO_EARTHQUAKE_SUCCESS,
  failureType: REFERENCE_INFO_EARTHQUAKE_FAILURE,
});

const getTsunamisSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}/tsunamis`, ...action }),
  requestType: REFERENCE_INFO_TSUNAMI_REQUEST,
  successType: REFERENCE_INFO_TSUNAMI_SUCCESS,
  failureType: REFERENCE_INFO_TSUNAMI_FAILURE,
});

const getRunupsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}/runups`, ...action }),
  requestType: REFERENCE_INFO_RUNUP_REQUEST,
  successType: REFERENCE_INFO_RUNUP_SUCCESS,
  failureType: REFERENCE_INFO_RUNUP_FAILURE,
});

const deleteVolcanoEventSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}`, ...action }),
  requestType: REFERENCE_INFO_VOLCANO_DELETE_REQUEST,
  successType: REFERENCE_INFO_VOLCANO_DELETE_SUCCESS,
  failureType: REFERENCE_INFO_VOLCANO_DELETE_FAILURE,
  successMessage: 'Deleted',
});

const deleteEarthquakeSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}`, ...action }),
  requestType: REFERENCE_INFO_EARTHQUAKE_DELETE_REQUEST,
  successType: REFERENCE_INFO_EARTHQUAKE_DELETE_SUCCESS,
  failureType: REFERENCE_INFO_EARTHQUAKE_DELETE_FAILURE,
  successMessage: 'Deleted',
});

const deleteTsunamiEventSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}`, ...action }),
  requestType: REFERENCE_INFO_TSUNAMI_DELETE_REQUEST,
  successType: REFERENCE_INFO_TSUNAMI_DELETE_SUCCESS,
  failureType: REFERENCE_INFO_TSUNAMI_DELETE_FAILURE,
  successMessage: 'Deleted',
});

const deleteRunupSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}`, ...action }),
  requestType: REFERENCE_INFO_RUNUP_DELETE_REQUEST,
  successType: REFERENCE_INFO_RUNUP_DELETE_SUCCESS,
  failureType: REFERENCE_INFO_RUNUP_DELETE_FAILURE,
  successMessage: 'Deleted',
});


export const referenceInfoSagas = [
  getReferenceSaga,
  getVolcanoesSaga,
  getEarthquakesSaga,
  getTsunamisSaga,
  getRunupsSaga,
  deleteVolcanoEventSaga,
  deleteEarthquakeSaga,
  deleteTsunamiEventSaga,
  deleteRunupSaga,
];
